import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';
import { AppSettingsService } from './app-settings.service';
import { RoomStateManagerService } from './room-state-manager.service';
import { SizeHelperService } from './size-helper.service';


@Injectable()
export class UnitsManagerService {

  constructor(private constants: ConstantsService,
    private appSettings: AppSettingsService,
    private roomStateManager: RoomStateManagerService,
    private sizeHelper: SizeHelperService 
    ) { }

  getWallLength(length) {
    if (this.appSettings.getSizeUnits() === this.constants.SizeUnit.CM)
      return length;
    else
      return this.sizeHelper.CMToINCH(length).toFixed(2) + '"';
  }

  getWallLengthToDisplayCorrectedMargin(length) {

    if (this.appSettings.getSizeUnits() === this.constants.SizeUnit.CM)
      return length + this.roomStateManager.calculateWallErrorMargin();
    else
      return this.sizeHelper.CMToINCH(length + this.roomStateManager.calculateWallErrorMargin()).toFixed(2) + '"';
  }

  getFloorArea(area) {
    if (this.appSettings.getSizeUnits() === this.constants.SizeUnit.FT)
      area = this.sizeHelper.convertM2ToFT2(area) + ' Sq. Ft.';
    // else
    //   area = floorArea.toFixed(2) + ' m\xB2';
    return area;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/units-manager.service.ts